/* eslint-disable no-unused-vars */
import { useCallback, useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import { UserDetailsContext } from "../context/userDetails";
import { JWTToken } from "../vars";
import { handleErrorMessage, setLocalStorageData } from "../utils/util";
import { auth0Service } from "../service/auth0service";



export default function useOtp() {
  const { email, name, setLinkType } = useContext(UserDetailsContext);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [otp, setOtp] = useState("");
  const navigate = useNavigate();

const sendOtp = useCallback(async ({userEmail = "", callBack, inviteCode,promptType,connection}) => {
		setLoading(true);
		setMessage("");
		try {
			await auth0Service.loginWithRedirect({email: userEmail, inviteCode,promptType,connection});
			if (callBack) {
				callBack();
			}
		} catch (error) {
			setMessage(handleErrorMessage(error));
		} finally {
			setTimeout(() => setLoading(false), 1000);
		}
	}, []);

  const verifyCode = useCallback(async ({route,callBack}) => {
    setLoading(true);
    try {
      await auth0Service.verifyPasswordless({email,code:otp});
      callBack?.();
      if (route) {
          navigate(route);
      }
    } catch (error) {
      setMessage(handleErrorMessage(error));
    } finally {
      setLoading(false);
    }
  }, [otp, email, name, navigate, setLinkType]);

  const silentLogin = async () => {
    try {
      const token = await auth0Service.silentLogin();
      console.log(token, "silent token");

      if (token) {
        setLocalStorageData(JWTToken, token || "");
        return true;
      }
    } catch (err) {
      if (
        err?.error === "login_required" ||
        err?.error === "consent_required" ||
        err?.error === "interaction_required" ||
        err?.error === "missing_refresh_token"
      ) {
        await auth0Service.loginWithRedirectOnly({});
      }
      console.log(err, "while silent login");
      return false;
    }
    return false;
  };



  const validateUserOnAppLoad = async (parmsEmail) => {
      
    try {
      const isAuth = await auth0Service.isAuthenticated();
      if (isAuth) {
        const user = await auth0Service.getUser();
        if ( parmsEmail && user?.email!== parmsEmail) {
          return { needsLogin: true };
        }
        try {
          const token = await silentLogin();
          console.log(token, "silent token");
        } catch (e) {
          console.warn("Could not store token:", e);
        }

        return { needsLogin: false, user };
      }
      const ssoSuccess = await silentLogin();
      if (ssoSuccess) {
        const user = await auth0Service.getUser();
        // if (parmsEmail && user?.email !== parmsEmail) {
        //   return { needsLogin: true };
        // }
        // postHogEvent({ email:user?.email,staus:"success",data:JSON.stringify({user}) }, "/silent-auth");
        return { needsLogin: false, user };
      }
      // postHogEvent({ staus: "failed" }, "/silent-auth");
      return { needsLogin: true };
    } catch (error) {
      console.log(error, "while validating user on app load");

      return { needsLogin: true };
    }
  };

  return {
    loading,
    message,
    otp,
    setOtp,
    sendOtp,
    verifyCode,
    setMessage,
    validateUserOnAppLoad
  };
}
